<div class="p-mb-2">
	<p-message severity="warn" text="Let op: zorg dat de gekozen diviesiecode ook daadwerkelijk bestaat in Irias Auth."></p-message>
</div>

<project-detail
	[inputProject]="newProject"
	(discardRequest)="discardProject($event)"
	(updateRequest)="createProject($event)"
>
</project-detail>
